import { defineMessages } from 'react-intl';
export default defineMessages({
  yourProducts: {
    id: 'wishlist.your.products',
    defaultMessage: 'Oblíbené produkty',
  },
  sharedProducts: {
    id: 'wishlist.shared.products',
    defaultMessage: 'Sdílené produkty',
  },
  noProducts: {
    id: 'wishlist.your.products.empty',
    defaultMessage: 'Zatím nemáte <b>oblíbené produkty</b> ',
  },
  notLogged: {
    id: 'wishlist.not.logged',
    defaultMessage:
      '<a>Přihlaste se</a> a vaše oblíbené produkty zůstanou uložené.',
  },
  emptyGuide: {
    id: 'wishlist.empty.guide',
    defaultMessage:
      'Jednoduše klikněte na symbol srdíčka u vaší oblíbené položky.',
  },
  productsCount: {
    id: 'wishlist.productsCount',
    defaultMessage: 'Produktů',
  },
  refreshButton: {
    id: 'wishlist.refreshButton.text',
    defaultMessage: 'Obnovit',
  },
});
